import { PortalBusServicingPeriodsQueryGQLType } from '~/backup/shared/views/deal-overview/dealOverview.gql.generated';

/** One of the deal's scheduled periods, with its cycle once the tape has reconciled. */
export type DealPeriod = PortalBusServicingPeriodsQueryGQLType['portalBusServicingPeriods'][number];

export type DealPeriodCycle = NonNullable<DealPeriod['cycle']>;

/**
 * Where a period lives on the deal page. The current period is the page itself,
 * so the Overview nav item stays lit and links stay short.
 */
export function periodPath({
  implementationId,
  period,
  current,
}: {
  implementationId: string;
  period: DealPeriod;
  current: DealPeriod | null;
}): string {
  return period.reportingPeriod === current?.reportingPeriod
    ? `/deals/${implementationId}`
    : `/deals/${implementationId}/periods/${period.reportingPeriod}`;
}
